module.exports = __webpack_public_path__ + "img/pointC_mark1.852eb22d.png";